import { Components } from '@mui/material/styles/components';
import theme from '../../provider/controllerBaseTheme';

export const AppBarComponent: Components = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.secondary.main,
      },
    },
  },
};
